import {COMMON} from '../common/index.js'

const {SERVICE_PROVIDERS} = COMMON
const {CARFAX, RESERVATION_B2C} = SERVICE_PROVIDERS

export const AVAILABLE_SERVICE_PROVIDERS = {
  [CARFAX]: CARFAX,
  [RESERVATION_B2C]: RESERVATION_B2C
}
